"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEnv_1 = require("./getEnv");
exports.getStaticHost = function () {
    var env = getEnv_1.getEnv();
    if (env !== 'live') {
        return 'https://' + env + 'apps.skypeassets.net';
    }
    return 'https://apps.skypeassets.com';
};
//# sourceMappingURL=getStaticHost.js.map